import React from "react"
import PaymentsSetupInstructions from "./PaymentsSetupInstructions"

type Props = {}

const PaymentsDashboard: React.FC<Props> = ({}) => {
  return (
    <div>
      <PaymentsSetupInstructions />
    </div>
  )
}

export default PaymentsDashboard
